import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Table, Alert } from 'react-bootstrap';
import i18n from 'kodyl-js/i18n/react';
import { Link } from 'react-router';

@i18n
class ContactDetail extends Component {
  static propTypes = {
    contact: PropTypes.object.isRequired
  };

  render() {
    const { contact, startPeriod } = this.props;

    const remarks = contact.remark.length
      ? contact.remark[0]
      : contact.type === 'nonprofit'
      ? 'Boligen er fra et alment boligselskab, der bl.a. kan have krav om betalt medlemsskab for at kunne komme i betragtning som lejer.'
      : null;

    return contact ? (
      <div>
        <Table striped condensed>
          <tbody>
            <tr>
              <th>{this.i18n('Address')}</th>
              <td>{contact.address || <i>{this.i18n('Not specified')}</i>}</td>
            </tr>
            {remarks ? (
              <tr>
                <th>{this.i18n('Please note')}</th>
                <td>{remarks}</td>
              </tr>
            ) : null}
            {contact.reference ? (
              <tr>
                <th>{this.i18n('Reference number')}</th>
                <td>{contact.reference}</td>
              </tr>
            ) : null}
            {contact.name ? (
              <tr>
                <th>{this.i18n('Landlord')}</th>
                <td>{contact.name}</td>
              </tr>
            ) : null}
            {contact.email ? (
              <tr>
                <th>{this.i18n('Email address')}</th>
                <td>{contact.email}</td>
              </tr>
            ) : null}
            {contact.phone ? (
              <tr>
                <th>{this.i18n('Phone')}</th>
                <td>{contact.phone}</td>
              </tr>
            ) : null}
            {contact.url /*&& !contact.email && !contact.phone*/ ? (
              <tr>
                <th>{this.i18n('Website')}</th>
                <td>
                  <a href={contact.url} target="_blank">
                    {this.i18n('Go to landlord')}
                  </a>
                </td>
              </tr>
            ) : null}
          </tbody>
        </Table>
        {startPeriod ? (
          <Alert bsStyle="danger">
            {this.i18n(
              'Vi mangler lige det sidste, før din profil er færdig. Følg linket, så er du hurtigt i gang med din boligjagt.'
            )}{' '}
            <Link to="/profile">{this.i18n('Klik her')}</Link>{' '}
          </Alert>
        ) : null}
      </div>
    ) : null;
  }
}

export default ContactDetail;
